<button type="button" class="audio" (click)="handleAudioClick()" [attr.aria-label]="(playAudio$ | async) ? 'Stop Audio' : 'Play Audio'">
  <app-icon
    [icon]="(playAudio$ | async) ? 'volume-up' : 'volume-slash'"
    class="audio__icon"></app-icon>

  <span class="audio__label text-10 text-uppercase text-semibold">
    {{ (playAudio$ | async) ? 'Stop Audio' : 'Play Audio' }}
  </span>
</button>
